/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarketingEventRequestModel
 */
export interface MarketingEventRequestModel {
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    bannerContent?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    bannerLinkTo?: string;
    /**
     * 
     * @type {number}
     * @memberof MarketingEventRequestModel
     */
    bannerPosition?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingEventRequestModel
     */
    discountId?: number;
    /**
     * 
     * @type {Date}
     * @memberof MarketingEventRequestModel
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    expireBannerContent?: string;
    /**
     * 
     * @type {Date}
     * @memberof MarketingEventRequestModel
     */
    expireBannerEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    isMegaSale?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    marketingEventName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketingEventRequestModel
     */
    memberIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketingEventRequestModel
     */
    memberLevelIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    mobileBannerContent?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    mobileExpireBannerContent?: string;
    /**
     * 
     * @type {string}
     * @memberof MarketingEventRequestModel
     */
    promotionCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof MarketingEventRequestModel
     */
    startDate?: Date;
}

export function MarketingEventRequestModelFromJSON(json: any): MarketingEventRequestModel {
    return MarketingEventRequestModelFromJSONTyped(json, false);
}

export function MarketingEventRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingEventRequestModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bannerContent': !exists(json, 'bannerContent') ? undefined : json['bannerContent'],
        'bannerLinkTo': !exists(json, 'bannerLinkTo') ? undefined : json['bannerLinkTo'],
        'bannerPosition': !exists(json, 'bannerPosition') ? undefined : json['bannerPosition'],
        'discountId': !exists(json, 'discountId') ? undefined : json['discountId'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'expireBannerContent': !exists(json, 'expireBannerContent') ? undefined : json['expireBannerContent'],
        'expireBannerEndDate': !exists(json, 'expireBannerEndDate') ? undefined : (new Date(json['expireBannerEndDate'])),
        'isMegaSale': !exists(json, 'isMegaSale') ? undefined : json['isMegaSale'],
        'marketingEventName': !exists(json, 'marketingEventName') ? undefined : json['marketingEventName'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
        'memberLevelIds': !exists(json, 'memberLevelIds') ? undefined : json['memberLevelIds'],
        'mobileBannerContent': !exists(json, 'mobileBannerContent') ? undefined : json['mobileBannerContent'],
        'mobileExpireBannerContent': !exists(json, 'mobileExpireBannerContent') ? undefined : json['mobileExpireBannerContent'],
        'promotionCode': !exists(json, 'promotionCode') ? undefined : json['promotionCode'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
    };
}

export function MarketingEventRequestModelToJSON(value?: MarketingEventRequestModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bannerContent': value.bannerContent,
        'bannerLinkTo': value.bannerLinkTo,
        'bannerPosition': value.bannerPosition,
        'discountId': value.discountId,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'expireBannerContent': value.expireBannerContent,
        'expireBannerEndDate': value.expireBannerEndDate === undefined ? undefined : (value.expireBannerEndDate.toISOString()),
        'isMegaSale': value.isMegaSale,
        'marketingEventName': value.marketingEventName,
        'memberIds': value.memberIds,
        'memberLevelIds': value.memberLevelIds,
        'mobileBannerContent': value.mobileBannerContent,
        'mobileExpireBannerContent': value.mobileExpireBannerContent,
        'promotionCode': value.promotionCode,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
    };
}

